import { render, staticRenderFns } from "./base-auth.vue?vue&type=template&id=8e053878"
var script = {}
import style0 from "./base-auth.vue?vue&type=style&index=0&id=8e053878&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports